import name from './name';
import sku from './sku';
import weight from './weight';
import active from './active';
import alias from './alias';
import warehouseLocation from './warehouseLocation';
import productProfileId from './productProfileId';
import createDateUTC from './createDateUTC';
import thumbnailUrl from './thumbnailUrl';
import allocated from './allocated';
import available from './available';
import dimensions from './dimensions';
import fulfillmentSKU from './fulfillmentSKU';
import customsTariffNo from './customsTariffNo';
import serviceId from './serviceId';
import intlServiceId from './intlServiceId';
import stock from './stock';
import inventory from './inventory';
import productType from './productType';
import tags from './tags';
import upc from './upc';
import productVariantIds from './productVariantIds';
import categoryId from './categoryId';
import modifyDateUTC from './modifyDateUTC';
import declaredValue from './declaredValue';
import totalAvailable from './total-available';
import autoSplit from './autosplit';
import activeShippingLocations from './activeShippingLocations';
import bundle from './bundle';
import committed from './committed';

export default {
  name,
  sku,
  weight,
  warehouseLocation,
  active,
  alias,
  productProfileId,
  createDateUTC,
  thumbnailUrl,
  allocated,
  available,
  dimensions,
  fulfillmentSKU,
  customsTariffNo,
  serviceId,
  intlServiceId,
  stock,
  inventory,
  productType,
  tags,
  upc,
  productVariantIds,
  categoryId,
  modifyDateUTC,
  declaredValue,
  totalAvailable,
  autoSplit,
  activeShippingLocations,
  bundle,
  committed,
};
